import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useAuth } from "./Auth/AuthPage.jsx";

const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;

const EditTitleButton = (props) => {
    return (
        <IconButton aria-label="edit title" onClick={props.onClick} size="small">
            <EditIcon sx={{ fontSize: "12px" }} />
        </IconButton>
    );
};

const EditTitleDialog = (props) => {
    const { open, onClose, title, documentId, onSave } = props;
    const { token, setFeedback } = useAuth();
    const [value, setValue] = useState(title || "");
    const [saving, setSaving] = useState(false);

    const handleSave = () => {
        setSaving(true);
        fetch(`${BACKEND_HOST}/events/${documentId}/editTitle`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ title: value })
        })
        .then(res => {
            // if ok, return json, else throw error
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
        })
        .then(response => {
           
            setFeedback({ message: response.message || "Saved", color: 'success' });
            onClose();
            if (typeof onSave === "function") onSave();
            
        })
        .catch(error => {
            console.error('Error saving title:', error);
            setFeedback({ message: "Failed to save title", color: 'error' });
          
        })
        .finally(() => {
            setSaving(false);
        });
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Edit Title</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Title"
                    fullWidth
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained" disabled={saving}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export const EditTitle = (props) => {
    const [open, setOpen] = useState(false);
    const { feedback } = useAuth();

    return (
        <>
            <EditTitleButton onClick={() => setOpen(true)} />
            <EditTitleDialog
                open={open}
                onClose={() => setOpen(false)}
                title={props.title}
                documentId={props.documentId}
                onSave={props.onSave}
            />
        </>
    );
};
